import DOMPurify from "dompurify";

const defaultConfig = {
  ALLOWED_TAGS: ["b", "i", "em", "strong", "a", "u", "br"],
  ALLOWED_ATTR: ["href", "target", "rel"],
  ADD_ATTR: ["rel"],
  FORBID_TAGS: ["script", "iframe", "object", "embed", "form", "input", "link", "meta", "style"],
  FORBID_ATTR: ["srcdoc", "srcset"],
  ALLOW_DATA_ATTR: false,
};

export const richHtmlConfig = {
  ALLOWED_TAGS: [
    "b",
    "i",
    "em",
    "strong",
    "a",
    "u",
    "br",
    "p",
    "span",
    "div",
    "ul",
    "ol",
    "li",
    "h1",
    "h2",
    "h3",
    "h4",
    "blockquote",
  ],
  ALLOWED_ATTR: ["href", "target", "rel", "class"],
  ADD_ATTR: ["rel"],
  FORBID_TAGS: ["script", "iframe", "object", "embed", "form", "input", "link", "meta", "style"],
  FORBID_ATTR: ["srcdoc", "srcset"],
  ALLOW_DATA_ATTR: false,
};

if (typeof window !== "undefined" && !window.__WLJ_DOMPURIFY_HOOKS__) {
  window.__WLJ_DOMPURIFY_HOOKS__ = true;
  DOMPurify.addHook("afterSanitizeAttributes", (node) => {
    if (node.tagName === "A") {
      const href = (node.getAttribute("href") || "").trim().toLowerCase();
      if (href.startsWith("javascript:") || href.startsWith("data:") || href.startsWith("vbscript:")) {
        node.removeAttribute("href");
      }
      node.setAttribute("rel", "noopener noreferrer nofollow");
      if (node.getAttribute("target") === "_blank") {
        node.setAttribute("rel", "noopener noreferrer nofollow");
      }
    }
  });
}

export function sanitizeHtml(html, config = defaultConfig) {
  if (!html || typeof html !== "string") return html ?? "";
  return DOMPurify.sanitize(html, config);
}

export function sanitizeRichHtml(html) {
  return sanitizeHtml(html, richHtmlConfig);
}

export default sanitizeHtml;
